import isNil from 'lodash/isNil'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import type Field from 'modules/custom_resources/store/models/customResources/Field'
import type Value from 'modules/custom_resources/store/models/customResources/Value'
import { defaultValue } from 'modules/employees/components/CustomResources/SchemaComponent/Form/utils/defaultValue'

type ReturnType = string | null | boolean | number | string[]

const coerceValueFromType = (field: Field, fieldValue: Value): ReturnType => {
  const id = field.attributes.id.toString()
  const value = fieldValue.attributes[id]

  if (isNil(value)) {
    return defaultValue(field.attributes.field_type)
  }

  switch (field.attributes.field_type) {
    case FieldTypes.cents:
    case FieldTypes.money:
      return +value

    default:
      return value
  }
}

export default coerceValueFromType
